import { Component } from "react"
import PropTypes from "prop-types"
import logAction from "../../utils/log_action"
import GreenCheck from "images/icons/icon-green-check.svg"

export default class SuggestedAppletsContainer extends Component {
  constructor(props) {
    super(props)
  }

  renderIcon(img, color, name, description, channelLink) {
    let formattedName = name.length > 15 ? name.slice(0, 15).concat("…") : name
    return (
      <div className="suggested-applet-card">
        <a href={channelLink} title={name}>
          <div
            className="tanda-icon"
            style={{
              backgroundColor: `#${color}`,
            }}
          >
            <img src={img} alt={name} />
            <div>{formattedName}</div>
          </div>
        </a>
        <div className="tanda-details">{description}</div>
      </div>
    )
  }

  renderSuggestedAppletCard(tanda, i) {
    return (
      <div className="suggested-applet-container" key={i}>
        <div className="suggested-applet-section">
          {this.renderIcon(
            tanda.trigger_channel_lrg_image_url,
            tanda.trigger_channel_brand_color,
            tanda.trigger_channel_name,
            tanda.trigger_name,
            tanda.trigger_channel_link
          )}
          {this.renderIcon(
            tanda.action_channel_lrg_image_url,
            tanda.action_channel_brand_color,
            tanda.action_channel_name,
            tanda.action_name,
            tanda.action_channel_link
          )}
        </div>
        <div className="suggested-applet-details">
          <p>
            <span>
              Suggested because:
              <br />
            </span>
            <b>This trigger and action pairing is popular.</b>
          </p>
          {tanda.exists ? (
            <div>
              <span
                className="svg-icon"
                dangerouslySetInnerHTML={{ __html: GreenCheck }}
              />
              <b>Applet created</b>
            </div>
          ) : (
            <a
              href={`${this.props.linkPath}?trigger_module_name=${tanda.trigger_module_name}&action_module_name=${tanda.action_module_name}&title=${tanda.title}&description=${tanda.description}`}
              className="button-secondary"
              data-turbolinks="false"
              onClick={() => {
                logAction("clicked_suggested_applet", {
                  service_slug: tanda.trigger_channel_module_name,
                })
              }}
            >
              Create Applet
            </a>
          )}
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="suggested-content-container">
        {this.props.tandas.map((tandaObj, i) => {
          return this.renderSuggestedAppletCard(tandaObj, i)
        })}
      </div>
    )
  }
}

SuggestedAppletsContainer.propTypes = {
  tandas: PropTypes.arrayOf(PropTypes.object),
  linkPath: PropTypes.string,
}
